import { Om } from '../skall/Om.tsx';
import type { Tall } from './tilstand.ts';

/**
 * Tre tall uten prosa (F9, F15): etiketten i `small`, tallet i `h1`, og bare det ene som
 * teller NÅ i full styrke — resten er dempet (DD-67: én helt per skjerm).
 *
 * Regelen bak tallene står i «Om tallene», lukket til noen spør (`Om`-laget, nivå to): at
 * dette er tellinger og ikke personer, at en som har akseptert står som «ikke slått på»
 * til leietakeren bekrefter flagget, og at samtykket gis ved aksept og aldri arves (P1).
 * Den sto som fire setninger under fire tellekort på flaten før R2.3.
 */
export function Tallrekke({ rader, testid = 'prg-tall', om = true }: { rader: Tall[]; testid?: string; om?: boolean }) {
  return (
    <div className="panel-prg-tallrekke" data-testid={testid}>
      {rader.map((r) => (
        <div key={r.key} className="panel-prg-tall-post" data-testid={r.testid ?? `prg-tall-${r.key}`}>
          <span className="panel-etikett">{r.navn}</span>
          <span className={`panel-prg-tall-verdi${r.dempet ? ' panel-prg-tall-dempet' : ''}`}>
            {r.verdi}
            {r.tillegg ? <span className="panel-prg-tall-tillegg"> {r.tillegg}</span> : null}
          </span>
        </div>
      ))}
      {om ? (
        <Om tittel="tallene" testid="prg-om-tallene">
          <p>Tallene er tellinger, aldri personer — det finnes ingen liste å ringe fra, ingen poeng og ingen rangering av testere.</p>
          <p>En som har akseptert står som «ikke slått på» til dere bekrefter at flagget er på for pseudonymet. Første bekreftelse tar programmet fra åpent til aktivt — plattformen rører aldri flagget selv.</p>
          <p>«Trukket» betyr at testeren gikk ut selv. Segmentet er oppdatert med én gang; raden står til dere bekrefter at flagget er tatt av.</p>
          <p>Samtykket til selve programmet gir testeren ved aksept, per program, og det arves aldri.</p>
        </Om>
      ) : null}
    </div>
  );
}
